module.exports = __webpack_public_path__ + "img/10.c9c34cc2.jpg";